/* eslint-disable no-unused-vars */
import styled from 'styled-components';
import { Card, Divider as DIV, Fab, Grid } from '@mui/material';
import Typography from '@app/components/atoms/Typography';
import { devices, deviceSizes } from '@app/config/devices';

export const Container = styled.div`
  padding: 1rem;
 
`;

export const DateContainer = styled.div`
  && {
    margin-top: 1rem;
  }
`;

export const Divider = styled(DIV)`
  width: 100%;
`;

export const ApplyButton = styled(Fab)`
  && {
    padding-left: 24px;
  }
`;

export const ErrorList = styled.ul`
  color: ${({ theme }) => theme.red[400]};
  margin-top: 0;
`;


export const FormField = styled(Grid)`
  && {
    .fieldTitle {
      border-left: 3px solid ${({ theme }) => theme.primary.main};
      padding-left: 10px;
    }
    .inputBox {
      width: 100%;
      // width: 60%;
      // @media (max-width: ${deviceSizes.mobileL}) {
      //   width: 100%;
      // }
    }
  }
`;

export const TermsContainer = styled.div`
  && {
    /* margin: 1rem 0; */
    max-height: 15.625rem;
    overflow-y: scroll;
    margin-bottom: 4rem;
    margin-top: 1rem;
    word-break: break-word;
  }
`;

export const CaptchaContainer = styled.div`
  @media ${devices.xs} {
    margin-right: auto;
    margin-left: auto;
    width: fit-content;
  }
`;

export const FormLabel = styled(Typography)`
  && {
    margin-top: 1rem;
  }
`;

